import { ActionButton, InputFieldV2, Text, Notifications } from "../custom-components";
import { IcDocument } from "../custom-components/Icon";
import "../styles/dataProtectionOfficer.css";
import "../styles/pageConfiguration.css";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  clearSession,
  getDPODetails,
  submitDPODetails,
  updateDPODetails,
} from "../store/actions/CommonAction";
import "../styles/toast.css";
import { Slide, ToastContainer, toast } from "react-toastify";
import CustomToast from "./CustomToastContainer";
import { useNavigate } from "react-router-dom";
import { CLEAR_SESSION } from "../store/constants/Constants";
import "../styles/sessionModal.css";
import ConfigurationShimmer from "./ConfigurationShimmer";

const DPO = () => {
  const [dpoName, setDpoName] = useState("");
  const [dpoemail, setDpoEmail] = useState("");
  const [dpophone, setDpiPhone] = useState("");
  const [dpoaddress, setDpoAddress] = useState("");
  const [readyToSubmit, setReadyToSubmit] = useState(false);
  const [disableSaveBtn, setDiableSaveBtn] = useState(false);
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [updateDPO, setUpdateDPO] = useState(false);
  const [dpoConfigId, setDpoConfigId] = useState("");
  const [loading, setLoading] = useState(true);
  var displayDPODetails = {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const phoneRegex = /^[6-9]\d{9}$/;
  const addressRegex = /^[A-Za-z0-9].*$/;
  const handleDpoNameChange = (e) => {
    let value = e.target.value;

    // collapse multiple spaces to single
    value = value.replace(/\s+/g, " ");

    // remove special characters (keep alphabets, digits, spaces)
    value = value.replace(/[^a-zA-Z0-9 ]/g, "");

    // trim leading space
    value = value.trimStart();

    setDpoName(value);
  };

  const handleDpoEmailChange = (e) => {
    let value = e.target.value;

    // remove all spaces
    value = value.replace(/\s+/g, "");

    setDpoEmail(value);
  };

  const handleDpoPhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // keep digits only
    setDpiPhone(value.slice(0, 10));
  };

  const handleDpoAddressChange = (e) => {
    let value = e.target.value;

    // collapse multiple spaces
    value = value.replace(/\s+/g, " ");

    // trim leading space
    value = value.trimStart();

    //  Require at least one alphabet
    const isValid = /[a-zA-Z]/.test(value);

    console.log("address val: ", value);

    if (isValid) {
      setDpoAddress(value);
    } else {
      setDpoAddress("");
    }
  };

  const handleDpoSubmit = async () => {
    const errors = [];

    // Name validation
    if (!/^(?=.*[A-Za-z])[A-Za-z0-9 ]+$/.test(dpoName.trim())) {
      errors.push("Please Enter Valid Data Protection Officer Name.");
    }

    // Email validation
    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})*$/;
    if (!emailRegex.test(dpoemail)) {
      errors.push("Please Enter Valid Email.");
    }

    //  Phone validation
    if (!/^\d{10}$/.test(dpophone) || !phoneRegex.test(dpophone)) {
      errors.push("Please Enter Valid Phone Number.");
    }

    // Address validation
    if (!addressRegex.test(dpoaddress.trim()) || dpoaddress.trim() === "") {
      errors.push("Please Enter Valid Address.");
    }

    if (errors.length > 1) {
      toast.error(
        (props) => (
          <CustomToast
            {...props}
            type="error"
            message={
              <ul style={{ margin: 0 }}>
                {errors.map((err, idx) => (
                  <li key={idx}>{err}</li>
                ))}
              </ul>
            }
          />
        ),
        { icon: false }
      );
    } else if (errors.length == 1) {
      toast.error(
        (props) => <CustomToast {...props} type="error" message={errors[0]} />,
        { icon: false }
      );
    } else {
      setReadyToSubmit(true);
      // var res = dispatch(submitDPODetails(dpoName, dpoemail, dpophone));

      try {
        const res = await dispatch(
          submitDPODetails(
            dpoName,
            dpoemail.toUpperCase(),
            dpophone,
            dpoaddress
          )
        );

        if (res.status === 500) {
          toast.error(
            (props) => (
              <CustomToast
                {...props}
                type="error"
                message={"Something went wrong..Please try again later"}
              />
            ),
            { icon: false }
          );
        } else if (res.status === 201) {
          toast.success(
            (props) => (
              <CustomToast
                {...props}
                type="success"
                message={"Settings saved successfully."}
              />
            ),
            { icon: false }
          );
        } else if (res.status === 401) {
          toast.error(
            (props) => (
              <CustomToast
                {...props}
                type="error"
                message={"Enter Valid DPO Details"}
              />
            ),
            { icon: false }
          );
        }
      } catch (error) {
        console.log("Error in DPO", error[0]);
        if (error[0]?.errorCode == "JCMP3003") {
          toast.error(
            (props) => (
              <CustomToast
                {...props}
                type="error"
                message={"Data Protection Officer is already exists."}
              />
            ),
            { icon: false }
          );
          setDiableSaveBtn(true);

          return;
        } else if (
          error[0].errorCode == "JCMP4003" ||
          error[0].errorCode == "JCMP4001"
        ) {
          toast.error(
            (props) => (
              <CustomToast
                {...props}
                type="error"
                message={"Session expored"}
              />
            ),
            { icon: false }
          );
          dispatch({ type: CLEAR_SESSION });
          setShowSessionModal(true);
          setTimeout(() => {
            setShowSessionModal(false);
            navigate("/adminLogin");
          }, 7000);
        } else {
          toast.error(
            (props) => (
              <CustomToast
                {...props}
                type="error"
                message={"something went wrong please try again later"}
              />
            ),
            { icon: false }
          );
          return;
        }
      }
    }
  };

  const handleDpoUpdate = async () => {
    const errors = [];

    // Name validation
    if (!/^(?=.*[A-Za-z])[A-Za-z0-9 ]+$/.test(dpoName.trim())) {
      errors.push("Please Enter Valid Data Protection Officer Name.");
    }

    // Email validation
    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})*$/;
    if (!emailRegex.test(dpoemail)) {
      errors.push("Please Enter Valid Email.");
    }

    //  Phone validation
    if (!/^\d{10}$/.test(dpophone) || !phoneRegex.test(dpophone)) {
      errors.push("Please Enter Valid Phone Number.");
    }

    // Address validation
    if (!addressRegex.test(dpoaddress.trim()) || dpoaddress.trim() === "") {
      errors.push("Please Enter Valid Address.");
    }

    if (errors.length > 1) {
      toast.error(
        (props) => (
          <CustomToast
            {...props}
            type="error"
            message={
              <ul style={{ margin: 0 }}>
                {errors.map((err, idx) => (
                  <li key={idx}>{err}</li>
                ))}
              </ul>
            }
          />
        ),
        { icon: false }
      );
    } else if (errors.length == 1) {
      toast.error(
        (props) => <CustomToast {...props} type="error" message={errors[0]} />,
        { icon: false }
      );
    } else {
      setReadyToSubmit(true);
      // var res = dispatch(submitDPODetails(dpoName, dpoemail, dpophone));

      try {
        const res = await dispatch(
          updateDPODetails(dpoName, dpoemail, dpophone, dpoaddress, dpoConfigId)
        );

        if (res.status === 500) {
          toast.error(
            (props) => (
              <CustomToast
                {...props}
                type="error"
                message={"Something went wrong..Please try again later"}
              />
            ),
            { icon: false }
          );
        } else if (res.status === 200) {
          toast.success(
            (props) => (
              <CustomToast
                {...props}
                type="success"
                message={"Settings updated successfully."}
              />
            ),
            { icon: false }
          );
          setTimeout(() => {
            navigate("/dpo-dashboard");
          }, 1500);
        } else if (res.status === 401) {
          toast.error(
            (props) => (
              <CustomToast
                {...props}
                type="error"
                message={"Enter Valid DPO Details"}
              />
            ),
            { icon: false }
          );
        }
      } catch (error) {
        console.log("Error in DPO", error[0]);
        if (error[0]?.errorCode == "JCMP3003") {
          toast.error(
            (props) => (
              <CustomToast
                {...props}
                type="error"
                message={"Data Protection Officer is already exists."}
              />
            ),
            { icon: false }
          );
          setDiableSaveBtn(true);

          return;
        } else if (
          error[0].errorCode == "JCMP4003" ||
          error[0].errorCode == "JCMP4001"
        ) {
          toast.error(
            (props) => (
              <CustomToast
                {...props}
                type="error"
                message={"Session expored"}
              />
            ),
            { icon: false }
          );
          dispatch({ type: CLEAR_SESSION });
          setShowSessionModal(true);
          setTimeout(() => {
            setShowSessionModal(false);
            navigate("/adminLogin");
          }, 7000);
        } else {
          toast.error(
            (props) => (
              <CustomToast
                {...props}
                type="error"
                message={"something went wrong please try again later"}
              />
            ),
            { icon: false }
          );
          return;
        }
      }
    }
  };

  useEffect(() => {
    const fetchDPO = async () => {
      try {
        setLoading(true);
        const response = await dispatch(getDPODetails());
        console.log("Searched DPO details:", response?.data?.searchList?.[0]);

        const dpoInfo = response?.data?.searchList?.[0]?.configurationJson;
        if (dpoInfo) {
          setDpoName(dpoInfo.name || "");
          setDpoEmail(dpoInfo.email || "");
          setDpiPhone(dpoInfo.mobile || "");
          setDpoAddress(dpoInfo.address || "");
          setUpdateDPO(true);
          setDpoConfigId(response?.data?.searchList?.[0]?.configId);
        } else {
          console.warn("No DPO details found in API response");
        }
      } catch (error) {
        console.error("Failed to fetch DPO details:", error);
        // ✅ Optional: show toast or fallback UI
        // toast.error("Failed to fetch DPO details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchDPO();
  }, [dispatch]);

  if (loading) {
    return <ConfigurationShimmer />;
  }

  return (
    <>
      {showSessionModal && (
        <div className="session-timeout-overlay">
          <div className="session-timeout-modal">
            <Text appearance="heading-s" color="feedback_error_50">
              Session Time Out
            </Text>
            <br></br>
            <Text appearance="body-s" color="primary-80">
              Your session has expired. Please log in again.
            </Text>
          </div>
        </div>
      )}
      <div className="configurePage" style={{ padding: "32px", minHeight: "calc(100vh - 80px)", boxSizing: "border-box", width: "100%", maxWidth: "100%", overflowX: "hidden", backgroundColor: '#F8FAFC', position: 'relative' }}>
        {/* Decorative background blob */}
        <div style={{ position: 'absolute', top: '-10%', right: '-5%', width: '40%', height: '50%', background: '#E0F2FE', borderRadius: '50% 40% 60% 40%', transform: 'rotate(-15deg)', filter: 'blur(80px)', zIndex: 0, opacity: 0.6 }}></div>

        <div style={{ position: 'relative', zIndex: 1, width: '100%', maxWidth: '100%', margin: '0 auto' }}>
          
          {/* Header Section */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '32px' }}>
            <div style={{ display: 'flex', gap: '16px' }}>
              <div style={{ width: '64px', height: '64px', backgroundColor: '#E0F2FE', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="#3B82F6">
                  <path d="M12 2C9.243 2 7 4.243 7 7C7 9.757 9.243 12 12 12C14.757 12 17 9.757 17 7C17 4.243 14.757 2 12 2ZM12 10C10.346 10 9 8.654 9 7C9 5.346 10.346 4 12 4C13.654 4 15 5.346 15 7C15 8.654 13.654 10 12 10Z"/>
                  <path d="M18.892 13.738C17.728 13.267 16.536 12.839 15.309 12.443C14.747 13.916 13.486 15 12 15C10.514 15 9.253 13.916 8.691 12.443C7.464 12.839 6.272 13.267 5.108 13.738C2.585 14.764 1 17.158 1 19.866V22H23V19.866C23 17.158 21.415 14.764 18.892 13.738Z"/>
                </svg>
              </div>
              <div>
                <h1 style={{ fontSize: '24px', fontWeight: '800', color: '#0F172A', margin: '0 0 8px 0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  Data Protection Officer (DPO)
                  <div className="custom-header-tooltip-container">
                    <div className="custom-header-tooltip-icon">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>
                      </svg>
                    </div>
                    <div className="custom-header-tooltip-text" style={{ width: '250px' }}>
                      The Data Protection Officer (DPO) is responsible for overseeing data protection practices and ensuring regulatory compliance within your organisation.
                    </div>
                  </div>
                </h1>
              </div>
            </div>
          </div>

          {/* Main Content Layout */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 380px', gap: '32px', alignItems: 'start' }}>
            
            {/* Form Section */}
            <div style={{ background: '#FFFFFF', borderRadius: '16px', padding: '32px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03)', border: '1px solid #E2E8F0', display: 'flex', flexDirection: 'column' }}>
              
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '32px' }}>
                <div style={{ width: '40px', height: '40px', background: '#E0F2FE', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                  </svg>
                </div>
                <div>
                  <h2 style={{ fontSize: '18px', fontWeight: '700', color: '#0F172A', margin: '0 0 4px 0' }}>DPO Contact Information</h2>
                  <p style={{ fontSize: '13px', color: '#64748B', margin: 0 }}>Enter the official contact details of your Data Protection Officer.</p>
                </div>
              </div>

              {/* Form Grid */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', width: '100%' }}>
                
                {/* Full Name */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '600', color: '#1E293B', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#475569" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    Full Name <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <input type="text" value={dpoName} onChange={handleDpoNameChange} placeholder="Enter full name" style={{ padding: '12px 16px', borderRadius: '8px', border: '1px solid #E2E8F0', outline: 'none', fontSize: '14px', width: '100%', boxSizing: 'border-box' }} />
                </div>

                {/* Email Address */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '600', color: '#1E293B', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#475569" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                    Email Address <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <input type="email" value={dpoemail} onChange={handleDpoEmailChange} placeholder="Enter email address" style={{ padding: '12px 16px', borderRadius: '8px', border: '1px solid #E2E8F0', outline: 'none', fontSize: '14px', width: '100%', boxSizing: 'border-box' }} />
                </div>

                {/* Phone Number */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '600', color: '#1E293B', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#475569" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                    Phone Number <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <div style={{ display: 'flex', border: '1px solid #E2E8F0', borderRadius: '8px', overflow: 'hidden' }}>
                    <div style={{ padding: '12px 16px', background: '#F8FAFC', borderRight: '1px solid #E2E8F0', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600', fontSize: '14px', color: '#334155' }}>
                      🇮🇳 +91
                    </div>
                    <input type="text" value={dpophone} onChange={handleDpoPhoneChange} placeholder="Enter phone number" maxLength={10} style={{ padding: '12px 16px', border: 'none', outline: 'none', fontSize: '14px', flex: 1, minWidth: 0 }} />
                  </div>
                </div>

                {/* Address */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label style={{ fontSize: '13px', fontWeight: '600', color: '#1E293B', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#475569" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                    Address <span style={{ color: '#EF4444' }}>*</span>
                  </label>
                  <input type="text" value={dpoaddress} onChange={handleDpoAddressChange} placeholder="Enter complete address" style={{ padding: '12px 16px', borderRadius: '8px', border: '1px solid #E2E8F0', outline: 'none', fontSize: '14px', width: '100%', boxSizing: 'border-box' }} />
                </div>
              </div>

              {/* Buttons */}
              <div style={{ display: 'flex', gap: '16px', marginTop: '48px', paddingTop: '24px', borderTop: '1px solid #E2E8F0' }}>
                <button
                  onClick={updateDPO ? handleDpoUpdate : handleDpoSubmit}
                  disabled={disableSaveBtn}
                  style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px', background: '#2563EB', color: '#FFF', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: disableSaveBtn ? 'not-allowed' : 'pointer', opacity: disableSaveBtn ? 0.7 : 1 }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>
                  Save Details
                </button>
                <button
                  style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 24px', background: '#F8FAFC', color: '#475569', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}
                  onClick={() => {
                    setDpoName("");
                    setDpoEmail("");
                    setDpiPhone("");
                    setDpoAddress("");
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path><polyline points="3 3 3 8 8 8"></polyline></svg>
                  Reset
                </button>
              </div>
            </div>

            {/* Sidebar Section */}
            <div style={{ background: '#F0F9FF', borderRadius: '16px', padding: '32px', display: 'flex', flexDirection: 'column' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
                <div style={{ width: '32px', height: '32px', background: '#2563EB', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                </div>
                <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#0F172A', margin: 0 }}>About DPO</h3>
              </div>
              
              <p style={{ fontSize: '13px', color: '#475569', lineHeight: '1.6', margin: '0 0 24px 0' }}>
                The Data Protection Officer (DPO) is the key point of contact for data protection matters and ensures compliance with applicable data protection laws and regulations.
              </p>

              <h4 style={{ fontSize: '14px', fontWeight: '700', color: '#1E293B', margin: '0 0 16px 0' }}>Typical Responsibilities</h4>
              
              <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {['Monitor data protection compliance', 'Advise on privacy-related matters', 'Act as a point of contact for regulators', 'Support data protection impact assessments'].map((item, idx) => (
                  <li key={idx} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '13px', color: '#475569', lineHeight: '1.4' }}>
                    <div style={{ width: '16px', height: '16px', background: '#3B82F6', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '2px' }}>
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                    </div>
                    {item}
                  </li>
                ))}
              </ul>

              {/* Decorative graphic at bottom */}
              <div style={{ marginTop: 'auto', paddingTop: '40px', display: 'flex', justifyContent: 'center' }}>
                <svg width="120" height="100" viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 90C20 84.4772 24.4772 80 30 80H90C95.5228 80 100 84.4772 100 90V100H20V90Z" fill="#DBEAFE"/>
                  <rect x="35" y="30" width="50" height="60" rx="4" fill="white" stroke="#BFDBFE" strokeWidth="2"/>
                  <rect x="45" y="45" width="30" height="6" rx="3" fill="#E2E8F0"/>
                  <rect x="45" y="60" width="20" height="6" rx="3" fill="#E2E8F0"/>
                  <rect x="45" y="75" width="25" height="6" rx="3" fill="#E2E8F0"/>
                  
                  <path d="M85 70V80C85 85.5228 80.5228 90 75 90H65C59.4772 90 55 85.5228 55 80V70C55 64.4772 59.4772 60 65 60H75C80.5228 60 85 64.4772 85 70Z" fill="#3B82F6"/>
                  <path d="M70 75V80" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                  <circle cx="70" cy="73" r="2" fill="white"/>
                  
                  <path d="M60 65C60 62.2386 62.2386 60 65 60H75C77.7614 60 80 62.2386 80 65V70H60V65Z" fill="#93C5FD"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="bottom-left"
        autoClose={3000}
        hideProgressBar
        closeOnClick
        pauseOnHover
        draggable
        closeButton={false}
        toastClassName={() => "toast-wrapper"}
        transition={Slide}
      />
    </>
  );
};

export default DPO;
